#import "~/graphql/fragments/sections/default/baseEntryFields.graphql"
#import "~/graphql/fragments/assets/image.graphql"

fragment grantAwardedPreview on grantAwarded_Entry {
    ... baseEntryFields
    featuredImage {
        ... image
    }
    shortDescription
}
